import { axios } from "utils";

export const getAllSMS = (query = "") =>
  axios.get(`/sms${query}`).then((res) => res.data);

export const sendSms = (payload) => axios.post("/sms", payload).then((res) => res.data);